import React, { useState, useEffect } from 'react';
import '../Contact/Contact.css';
import validator from 'validator';
import { FaEnvelope, FaPhoneAlt, FaClock, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';
import axios from 'axios';
import { useTheme } from '../../contexts/ThemeContext';

function Contact() {
  const { theme } = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  const [errors, setErrors] = useState({});
  const [dataSubmittedMessage, setDataSubmittedMessage] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    number: '',
    message: '',
  });

  const clearData = () => {
    setFormData({
      name: '',
      email: '',
      number: '',
      message: '',
    });
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: '',
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validator.isEmail(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!formData.number.trim()) {
      newErrors.number = 'Phone number is required';
    } else if (!validator.isMobilePhone(formData.number, 'any')) {
      newErrors.number = 'Invalid phone number';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();

    if (Object.keys(newErrors).length === 0) {
      setDataSubmittedMessage(true);
      clearData();
      setTimeout(() => {
        setDataSubmittedMessage(false);
      }, 5000);

      try {
        const response = await axios.post(
          'https://amruth-build-products-backend.onrender.com/contact',
          formData
        );
        console.log('Form submitted successfully!', response.data);
      } catch (error) {
        console.error('Error submitting the form:', error);
      }
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <div className='modern-contact-container'>
      {/* Hero Section */}
      <section className='contact-hero-section'>
        <div className='hero-background'></div>
        <div className='hero-overlay'></div>
        <div className='container hero-content'>
          <div className={`hero-text text-center ${isVisible ? 'animate-in' : ''}`}>
            <h1 className='hero-title'>
              <span className='text-gradient'>Contact</span> Us
            </h1>
            <p className='hero-description'>
              Ready to embark on your next project? Connect with us today and let's build a future together.
            </p>
          </div>
        </div>
      </section>
      
      {/* Contact Section */}
      <section className='contact-section'>
        <div className='container'>
          <div className='contact-grid'>
            {/* Contact Information */}
            <div className='contact-info'>
              <h3>Get in Touch</h3>
              <div className='contact-details'>
                <div className='contact-item'>
                  <div className='contact-icon'>
                    <FaMapMarkerAlt />
                  </div>
                  <div className='contact-text'>
                    <h4>Address</h4>
                    <p>Amruth Build Products, Beside Amrutha bindu petrol bunk<br />
                    Malladihalli, Holalkere (tq)<br />
                    Chitradurga (Dist), Karnataka - 577531</p>
                  </div>
                </div>
                <div className='contact-item'>
                  <div className='contact-icon'>
                    <FaPhoneAlt />
                  </div>
                  <div className='contact-text'>
                    <h4>Phone</h4>
                    <p><a href="tel:+917676817230" className='contact-link'>+91 7676817230</a></p>
                  </div>
                </div>
                <div className='contact-item'>
                  <div className='contact-icon'>
                    <FaEnvelope />
                  </div>
                  <div className='contact-text'>
                    <h4>Email</h4>
                    <p><a href="mailto:amruthbuildproducts@gmail.com" className='contact-link'>amruthbuildproducts@gmail.com</a></p>
                  </div>
                </div>
                <div className='contact-item'>
                  <div className='contact-icon'>
                    <FaClock />
                  </div>
                  <div className='contact-text'>
                    <h4>Business Hours</h4>
                    <p>Mon - Sat: 9:00 AM - 6:00 PM</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Contact Form */}
            <div className='contact-form'>
              <h3 className='form-title'>Send us a Message</h3>
              {dataSubmittedMessage && (
                <div className='success-message'>
                  Thank you! Your message has been sent successfully.
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className='form-group'>
                  <label className='form-label'>Name *</label>
                  <input
                    type='text'
                    name='name'
                    value={formData.name}
                    onChange={handleChange}
                    className={`form-input ${errors.name ? 'error' : ''}`}
                    placeholder='Enter your name'
                  />
                  {errors.name && <div className='form-error'>{errors.name}</div>}
                </div>
                
                <div className='form-group'>
                  <label className='form-label'>Email *</label>
                  <input
                    type='email'
                    name='email'
                    value={formData.email}
                    onChange={handleChange}
                    className={`form-input ${errors.email ? 'error' : ''}`}
                    placeholder='Enter your email'
                  />
                  {errors.email && <div className='form-error'>{errors.email}</div>}
                </div>
                
                <div className='form-group'>
                  <label className='form-label'>Phone Number *</label>
                  <input
                    type='tel'
                    name='number'
                    value={formData.number}
                    onChange={handleChange}
                    className={`form-input ${errors.number ? 'error' : ''}`}
                    placeholder='Enter your phone number'
                  />
                  {errors.number && <div className='form-error'>{errors.number}</div>}
                </div>
                
                <div className='form-group'>
                  <label className='form-label'>Message *</label>
                  <textarea
                    name='message'
                    value={formData.message}
                    onChange={handleChange}
                    className={`form-textarea ${errors.message ? 'error' : ''}`}
                    placeholder='Enter your message'
                    rows='5'
                  ></textarea>
                  {errors.message && <div className='form-error'>{errors.message}</div>}
                </div>
                
                <button type='submit' className='submit-btn'>
                  <FaPaperPlane />
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
